<template>
    <div id="data-list-thumb-view" class="data-list-container">
    <vs-table ref="table" :max-items="20" pagination search :data="invoiceables">
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <h1>Te factureren items</h1>
            <div
                    class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
            >
                <span class="ml-2 text-base text-primary" @click="openCreateInvoiceableModal">Toevoegen</span>
            </div>
        </div>
        <template slot="thead">
            <vs-th sort-key="company_name">Bedrijf</vs-th>
            <vs-th sort-key="phone_number">Bedrag</vs-th>
            <vs-th sort-key="status">Status</vs-th>
            <vs-th sort-key="description">Beschrijving</vs-th>
            <vs-th sort-key="description">Acties</vs-th>
        </template>

        <template slot-scope="{data}">
            <tbody>
            <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                    @click.native="openInvoiceableModal(tr)"
            >
                <vs-td>
                    <p class="company-name">{{ tr.company.name }}</p>
                </vs-td>

                <vs-td>
                    <p class="deliverer-phone_number">{{ tr.price }}</p>
                </vs-td>
                <vs-td>
                    <p class="deliverer-phone_number">{{ tr.status }}</p>
                </vs-td>
                <vs-td>
                    <p class="deliverer-phone_number">{{ tr.description }}</p>
                </vs-td>
                <vs-td >
                    <p class="deliverer-phone_number"> <vs-button
                            color="danger"
                            type="flat"
                            ref="loadableButton"
                            icon-pack="feather"
                            icon="icon-trash-2"
                            @click.stop="startDelete(tr)"
                    ></vs-button></p>
                </vs-td>

            </vs-tr>
            </tbody>
        </template>
    </vs-table>
        <ht-invoiceable-popup></ht-invoiceable-popup>
    </div>
</template>
<script>
    import InvoiceablePopup from "./InvoiceablePopup";

    export default {
        data() {
            return {
                selected: [],
                invoiceables: [],
                activeConfirm: false
            };
        },

        components: {
            "ht-invoiceable-popup": InvoiceablePopup
        },

        methods: {
            getInvoiceables() {
                this.$http.get('/v1/invoice-ables')
                    .then((response) => {
                        this.invoiceables = response.data;
                    })
                    .catch((error) => {
                        this.$util.logError(error, this.$vs);
                    });
            },

            startDelete(invoiceable) {
                this.$vs.dialog({
                    type:'confirm',
                    color: 'danger',
                    title: 'Weet je het zeker',
                    text: 'Hiermee verwijder je de geselecteerde invoiceable',
                    accept: function() {
                        this.loading = true;
                        let data = new FormData();
                        data.append('_method', 'DELETE');
                        data.append('id', invoiceable.id);
                        this.$http
                            .post("v1/invoice-able/delete", data, {
                                headers: {
                                    Authorization:
                                        "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
                                },
                            })
                            .then(() => {
                                this.loading = false;
                                this.$events.fire('refresh-invoiceables');
                                this.$util.notify('Gelukt', 'Invoiceable is verwijderd!', this.$vs);
                            })
                            .catch((error) => {
                                this.$vs.loading.close("#delete-invoiceable-button > .con-vs-loading");
                                this.loading = false;
                                this.$util.logError(error, this.$vs);
                            });
                    }
                })
            },
            openInvoiceableModal(invoiceAble) {
                this.$events.fire('open-invoiceable-modal', invoiceAble);
            },

            openCreateInvoiceableModal() {
                this.$events.fire('open-invoiceable-create-modal');
            }
        },

        mounted() {
            this.getInvoiceables();
            this.$events.listen('refresh-invoiceables', () => {
                this.getInvoiceables();
            });
        }
    };
</script>